import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';

const UserDistributionChart = ({ data }) => {
  const COLORS = {
    clients: 'var(--color-primary)',
    contractors: 'var(--color-accent)',
    affiliates: 'var(--color-success)'
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-popover border border-border rounded-lg p-3 elevation-md">
          <p className="caption text-foreground font-medium mb-1">
            {payload?.[0]?.name}
          </p>
          <p className="caption text-muted-foreground">
            {payload?.[0]?.value} gebruikers ({payload?.[0]?.payload?.percentage}%)
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div 
      className="bg-white border-2 border-slate-200 rounded-lg p-4 md:p-6"
      style={{
        boxShadow: '0 15px 40px rgba(0,0,0,0.15), 0 8px 20px rgba(0,0,0,0.1)'
      }}
    >
      <div className="mb-4 md:mb-6">
        <h3 className="text-lg md:text-xl font-semibold text-foreground mb-1">
          Gebruikers Verdeling
        </h3>
        <p className="caption text-muted-foreground">
          Actieve gebruikers per type
        </p>
      </div>
      <div className="w-full h-64 md:h-80" aria-label="User Distribution Pie Chart">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={({ name, percentage }) => `${name}: ${percentage}%`}
              outerRadius={80}
              fill="#8884d8"
              dataKey="value"
            >
              {data?.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS?.[entry?.id]} />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
            <Legend 
              verticalAlign="bottom" 
              height={36}
              wrapperStyle={{ fontSize: '14px' }}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default UserDistributionChart;